<template>
  <div class="page-content">
    <div class="payment">
      <div class="payment-header">
        <CustomIcon name="logo" class="payment-header-logo" />
        <h2 class="payment-title">{{ screenTitleText }}</h2>
      </div>
      <h3 class="payment-subtitle">How it works</h3>
      <div class="faq-step">
        <div class="faq-step-icon">
          <CustomIcon name="unlock" />
        </div>
        <div class="faq-step-content">
          <h4 class="faq-step-content-title">Today</h4>
          <p class="faq-step-content-description">
            {{ welcomeText }}
          </p>
        </div>
      </div>
      <div
        :style="{
          display: formData.headsetType.value === 'none' ? 'none' : 'block',
        }"
      >
        <div class="faq-step">
          <div class="faq-step-icon">
            <CustomIcon v-if="allianzReferrer" name="delivery-truck" />
            <CustomIcon v-else name="vr" />
          </div>
          <div class="faq-step-content">
            <h4 class="faq-step-content-title">{{ deliveryTime }} days</h4>
            <p class="faq-step-content-description">
              {{ startVRText }}
            </p>
          </div>
        </div>
      </div>

      <div v-if="allianzReferrer" class="faq-step">
        <div class="faq-step-icon">
          <CustomIcon name="vr" />
        </div>
        <div class="faq-step-content">
          <h4 class="faq-step-content-title">VR exposure</h4>
          <p class="faq-step-content-description">
            Once you've completed knowledge modules, start the VR exposure
          </p>
        </div>
      </div>
      <!-- delivery not needed for easeup -->
      <div
        :style="{
          display:
            easeUpReferrer ||
            vapingReferrer ||
            formData.headsetType.value === 'none'
              ? 'none'
              : 'block',
        }"
      >
        <h3 class="payment-subtitle">Your VR headset</h3>
        <div class="payment-image">
          <img
            :src="require('@/assets/images/ovrcome_vr_headset.png')"
            name="ovrcome-headset"
            alt="ovrcome-headset-image"
          />
        </div>
        <!-- <div class="radio-set">
          <RadioSelect
            :onClick="() => updateForm('headsetType', 'regular', true)"
            :isActive="formData.headsetType.value === 'regular'"
            label="Send me a VR headset"
          /> -->
        <!-- <RadioSelect
            :onClick="() => updateForm('headsetType', 'none', true)"
            :isActive="formData.headsetType.value === 'none'"
            label="I’ll use my own VR headset for mobile phones"
          /> -->
        <!-- </div> -->

        <div>
          <h3 class="payment-address-info">
            A VR headset for smartphones is included in this order.
          </h3>
          <h3
            v-if="!easeUpReferrer || !vapingReferrer"
            class="payment-address-info"
          >
            After verifying your address, please make sure it's complete and
            includes the unit or apartment number, where applicable.
          </h3>
          <div v-if="this.allianzReferrer" class="payment-checkbox-div">
            <input
              class="payment-checkbox-style"
              type="checkbox"
              v-model="addressUnderstood"
            />
            <span class="payment-checkbox-text"
              >I understand that the address is required for the dispatch of the
              headset only.</span
            >
          </div>
        </div>
        <div :class="getPaymentFormClass()">
          <h3 class="payment-subtitle">Delivery address</h3>
          <FieldInput
            name="name"
            placeholder="e.g. Bob Smith"
            labelText="Full Name"
            :value="formData.name.value"
            :touched="formData.name.touched"
            :onBlur="() => updateForm('name', formData.name.value, true)"
            :onChange="(event) => updateForm('name', event.target.value, true)"
            :validator="(value) => validator['name'](value)"
          />
          <div :class="getAddressClass()">
            <label for="street-address" class="field-label"
              >Street Address</label
            >
            <input
              tabindex="0"
              ref="streetAddressLookUp"
              class="field-input"
              type="text"
              id="street-address"
              placeholder="e.g. Building number and street name"
              :value="formData.address.value"
              :touched="formData.address.touched"
              @focus="() => updateForm('address', formData.address.value, true)"
              @blur="() => updateForm('address', formData.address.value, true)"
              @change="
                (event) => updateForm('address', event.currentTarget.value)
              "
              @input.once="autoCompleteService()"
            />
            <label
              v-if="
                !validator['address'](this.formData.address.value).valid &&
                this.formData.address.touched
              "
              class="field-status"
              ><CustomIcon name="warning" />Address is required</label
            >
          </div>
          <FieldInput
            name="apartment"
            labelText="Address Line 2 (optional)"
            placeholder="e.g. Unit/Suite/Apt number"
            :value="formData.apartment.value"
            :touched="formData.apartment.touched"
            :onBlur="
              () => updateForm('apartment', formData.apartment.value, true)
            "
            :onChange="
              (event) => updateForm('apartment', event.target.value, false)
            "
            :validator="(value) => validator['apartment'](value)"
          />
          <FieldInput
            name="locality"
            placeholder="e.g. Dallas"
            labelText="City"
            :value="formData.locality.value"
            :touched="formData.locality.touched"
            :onBlur="
              () => updateForm('locality', formData.locality.value, true)
            "
            :onChange="
              (event) => updateForm('locality', event.target.value, false)
            "
            :validator="(value) => validator['locality'](value)"
          />
          <FieldSelector
            labelText="Country"
            :options="countries"
            placeholder="Select Country"
            :value="formData.countryAlpha2.value"
            :touched="formData.countryAlpha2.touched"
            :onBlur="updateCountryField"
            :onChange="updateCountryField"
            :validator="(value) => validator['country'](value)"
          />
          <FieldSelector
            :disabled="!formData.countryId.value"
            placeholder="e.g. Texas"
            name="state-selector"
            type="selector"
            :autoComplete="false"
            labelText="State/Province"
            :options="states"
            :value="formData.stateId.value"
            :touched="formData.stateId.touched"
            :onBlur="() => updateForm('stateId', formData.stateId.value, true)"
            :onChange="
              (event) => updateForm('stateId', event.target.value, false)
            "
            :validator="(value) => validator['state'](value)"
          />
          <FieldInput
            name="postal"
            labelText="Zipcode/Postcode"
            placeholder="e.g. 73301"
            :value="formData.postal.value"
            :touched="formData.postal.touched"
            :onBlur="() => updateForm('postal', formData.postal.value, true)"
            :onChange="
              (event) => updateForm('postal', event.target.value, false)
            "
            :validator="(value) => validator['postal'](value)"
          />
          <FieldInput
            name="phoneNumber"
            labelText="Phone number (Required for shipping)"
            placeholder="e.g. +1 555 555 5555"
            :value="formData.phoneNumber.value"
            :touched="formData.phoneNumber.touched"
            :onBlur="
              () => updateForm('phoneNumber', formData.phoneNumber.value, true)
            "
            :onChange="
              (event) => updateForm('phoneNumber', event.target.value, false)
            "
            :validator="(value) => validator['phoneNumber'](value)"
          />
        </div>
      </div>
      <div
        :style="{
          display: easeUpReferrer || allianzReferrer ? 'none' : 'block',
        }"
      >
        <h3
          class="payment-subtitle"
          :style="{
            display: vapingReferrer ? 'none' : 'block',
          }"
        >
          Payment Summary
        </h3>
        <SummaryBox
          title="Pay Now"
          :listItems="getSummaryItems()"
          :summaryItem="getSubscriptionSummary()"
          :footerText="getFooterText()"
          :style="{
            display: vapingReferrer ? 'none' : 'block',
          }"
        />
        <PromoCode
          :value="formData.promoCode.value"
          :touched="formData.promoCode.touched"
          :onChange="
            (value, touched) => updateForm('promoCode', value, touched)
          "
          :onBlur="() => updateForm('promoCode', value, touched)"
          :onSubmit="
            (event) => handleSubmitPromoCode(event, formData.promoCode.value)
          "
        />
      </div>
      <p v-if="formData.promoApplied.value">
        Promo Applied: <b>{{ formData.promoApplied.value }}</b>
      </p>
      <p class="payment-text">
        {{ paymentText }}
      </p>
      <p
        :style="{ display: bespokeReferrer ? 'none' : 'block' }"
        class="payment-text"
      >
        Prices in USD.
      </p>
      <SnackbarPrompt v-if="errorMessage" icon="warning" variation="warning">{{
        errorMessage
      }}</SnackbarPrompt>
      <div v-if="!getTotalCost().collectPaymentDetails">
        <CustomButton
          :disabled="!formIsValid(true) || isLoadingVoucherProcess"
          :onClick="() => submitVoucherProcess()"
        >
          <span v-if="!isLoadingVoucherProcess">Confirm</span>
          <LoadingIndicator v-else />
        </CustomButton>
      </div>
      <div
        v-else
        :style="{
          display: vapingReferrer ? 'none' : 'block',
        }"
      >
        <h3 class="payment-subtitle">Pay with</h3>
        <StripePaymentForm
          :onSubmit="submitStripeProcess"
          label="Card number"
          :isPaymentRequired="true"
          :fieldIsComplete="(value) => (this.cardDetailsAreCompleted = value)"
        >
          <div v-if="!isErrorAfterPaying">
            <CustomButton :disabled="isLoadingStripePayment">
              <span v-if="!isLoadingStripePayment">Confirm and Pay</span>
              <LoadingIndicator v-else />
            </CustomButton>
          </div>
        </StripePaymentForm>
      </div>
    </div>
  </div>
</template>
<script>
import FieldInput from "@/components/FieldInput.vue";
import SummaryBox from "@/components/SummaryBox.vue";
import SnackbarPrompt from "@/components/SnackbarPrompt.vue";
import FieldSelector from "@/components/FieldSelector.vue";
import StripePaymentForm from "@/components/StripePaymentForm.vue";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import CustomButton from "@/components/CustomButton.vue";
import CustomIcon from "@/components/CustomIcon.vue";
import { MODULES, PAYMENT_FORMS, PAGE_PATH } from "@/config";
import { mapGetters } from "vuex";
import {
  fillInAddress,
  webPaymentDeliveryValidator,
  denormaliseWebPaymentForm,
  denormaliseOrderSummary,
  denormaliseNoHeadsetOrderSummary,
  getCategoryById,
} from "@/utils";
import GooglePlaces from "@/services/google-places";
import classnames from "classnames";
import { pageInformationMixin } from "@/mixins";
import PromoCode from "@/components/PromoCode.vue";
import { purchase_event_payload } from "@/utils/tracking/google";
import * as queryString from "query-string";
export default {
  data() {
    return {
      validator: webPaymentDeliveryValidator,
      cardDetailsAreCompleted: false,
      isLoadingStripePayment: false,
      isLoadingVoucherProcess: false,
      isProduction: process.env.NODE_ENV === "production",
      errorMessage: null,
      easeUpReferrer: false,
      vapingReferrer: false,
      allianzReferrer: false,
      bespokeReferrer: false,
      screenTitleText: "Start subscription",
      deliveryTime: "5-14",
      startVRText: "Your VR headset arrives. Start your VR sessions.",
      paymentText:
        "We currently ship from the US and New Zealand. For overseas deliveries international shipping costs and timeframes will apply, as well as duty (where applicable).",
      welcomeText:
        "Get full access to oVRcome. Your VR headset will be shipped to you. Begin your daily audio lessons. Don’t wait for your headset!",
      addressUnderstood: false,
      autoLoadPromoCode: false,
    };
  },
  props: {
    updateFormState: Function,
    action: Function,
    formData: Object,
  },
  components: {
    FieldInput,
    SummaryBox,
    FieldSelector,
    SnackbarPrompt,
    StripePaymentForm,
    LoadingIndicator,
    CustomButton,
    CustomIcon,
    PromoCode,
  },
  mixins: [pageInformationMixin],
  watch: {
    headsetType: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.getSaleSummary(PAYMENT_FORMS.web);
        }
      },
      deep: true,
      immediate: false,
    },
  },
  computed: {
    ...mapGetters(MODULES.COUNTRY, {
      countries: "getCountries",
      states: "getCountryStates",
    }),
    ...mapGetters(MODULES.PLAN, {
      availablePlans: "getAvailablePlans",
    }),
    ...mapGetters(MODULES.WELCOME, {
      onboardingData: "getOnboardingData",
    }),
    ...mapGetters(MODULES.PAYMENT, {
      orderSummary: "getOrderSummary",
      getPaymentForm: "getPaymentForm",
      isErrorAfterPaying: "getIsErrorAfterPaying",
    }),
    headsetType() {
      return this.formData.headsetType.value;
    },
  },
  mounted() {
    const { name_input, choose_path } = this.onboardingData;
    const { dispatch } = this.$store;
    if (choose_path === PAGE_PATH.myself) {
      this.updatePaymentFormState(PAYMENT_FORMS.web, "name", name_input, false);
    }
    if (this.countries.length === 0) {
      dispatch(`${MODULES.COUNTRY}/getCountriesAction`);
    }
    this.getSaleSummary(PAYMENT_FORMS.web);
    this.initGooglePlaces();

    this.autoLoadPromoCode = this.$route.query.code !== undefined;
    this.allianzReferrer = this.$route.query.referrer === "allianz";
    this.easeUpReferrer = this.$route.query.referrer === "ease_up";
    this.vapingReferrer = this.$route.query.referrer === "moe_vaping";
    this.bespokeReferrer =
      this.allianzReferrer || this.easeUpReferrer || this.vapingReferrer;

    if (this.bespokeReferrer) {
      this.paymentText = "";
    }

    if (this.formData.headsetType.value === "none") {
      //if no headset
      this.paymentText = "";
      this.welcomeText =
        "Get full access to oVRcome. Begin your daily audio lessons and VR exposure";
      this.updateForm("address", "", true);
      this.updateForm("locality", "", true);
      this.updateForm("stateId", "", true);
      this.updateForm("countryId", "", true);
      this.updateForm("countryAlpha2", "", true);
      this.updateForm("postal", "", false);
      this.updateForm("apartment", "", false);
    }

    if (this.allianzReferrer) {
      this.deliveryTime = "3-8";
      this.startVRText = "Your VR headset arrives";
      this.welcomeText =
        "Get full access to oVRcome. Begin your daily audio lessons. Don’t wait for your headset!";
      dispatch(`${MODULES.COUNTRY}/getCountryStatesById`, 172).then(() => {
        this.updateForm("countryId", 172, true);
        this.updateForm("countryAlpha2", "AU", true);
      });
    }

    if (this.vapingReferrer) {
      this.screenTitleText = "Start Program";
    }

    if (this.easeUpReferrer || this.vapingReferrer) {
      this.deliveryTime = "3+";
      this.welcomeText =
        "Get full access to oVRcome. Begin your daily audio lessons.";
      this.startVRText = "Start your VR sessions";
      this.updateAddressFormWithDefaultForEaseup();
    }

    if (this.autoLoadPromoCode) {
      this.handleSubmitPromoCode(null, this.$route.query.code);
      this.updateForm(
        "promoCode",
        this.formData.promoCode.value,
        this.formData.promoCode.touched
      );
    }
  },
  methods: {
    getAddressClass() {
      return classnames("field", {
        "is-invalid":
          !this.validator["address"](this.formData.address.value).valid &&
          this.formData.address.touched,
      });
    },
    getFooterText() {
      return null;
    },
    handleSubmitPromoCode(event, value) {
      if (event) {
        event.preventDefault();
      }
      this.getSaleSummary(PAYMENT_FORMS.web, { voucher_code: value });
    },
    formatPlanTitle(plan) {
      const { billing_units, price } = plan;
      return `$${Number(price.amount)} ${billing_units}`;
    },
    getPaymentFormClass() {
      return classnames("payment-form", {
        "is-hidden": this.formData.headsetType.value !== "regular",
      });
    },
    checkFormFilled() {
      this.updateForm("phoneNumber", this.formData.phoneNumber.value, true);
      this.updateForm("name", this.formData.name.value, true);
      this.updateForm("address", this.formData.address.value, true);
      this.updateForm("locality", this.formData.locality.value, true);
      this.updateForm("postal", this.formData.postal.value, true);
      this.updateForm("apartment", this.formData.apartment.value, true);
      this.updateForm("countryAlpha2", this.formData.countryAlpha2.value, true);
      this.updateForm("stateId", this.formData.stateId.value, true);
    },
    initGooglePlaces() {
      this.googleService = new GooglePlaces();
      this.googleService.init();
      this.autoComplete = new this.googleService.service.Autocomplete(
        this.$refs.streetAddressLookUp,
        {
          types: ["geocode"],
        }
      );
    },
    autoCompleteService() {
      this.autoComplete.addListener("place_changed", () => {
        const results = fillInAddress(this.autoComplete);
        this.autoCompleteForm(results);
        this.updateForm("phoneNumber", this.formData.phoneNumber.value, true);
      });
    },
    autoCompleteForm(results) {
      const blackListedKeys = ["country", "name", "stateId", "phoneNumber"]; // todo: setup seperate validator for these keys.
      const keys = Object.keys(this.formData);
      const properties = (validator, key) =>
        Object.prototype.hasOwnProperty.call(validator, key);
      keys.forEach((key) => {
        if (properties(this.validator, key) && !blackListedKeys.includes(key)) {
          const replaceLocality = this.shouldReplaceLocality(key, results);
          this.updateForm(
            key,
            replaceLocality ? results.sublocality : results[key],
            false
          );
        }
      });
      this.updateCountryFromGoogle(results.countryAlpha, results?.state);
    },
    shouldReplaceLocality(key, results) {
      return key === "locality" && !results[key] && results.sublocality;
    },
    updateForm(key, value, touched = false) {
      const { updatePaymentFormState } = this;
      updatePaymentFormState(PAYMENT_FORMS.web, key, value, touched);
    },
    updateCountryField(event) {
      const { updateForm } = this;
      const { dispatch } = this.$store;
      if (event) {
        event.preventDefault();
      }
      const countryObj = this.countries.find(
        (country) => event.target.value === country.value
      );
      dispatch(`${MODULES.COUNTRY}/getCountryStatesById`, countryObj.id).then(
        () => {
          updateForm("countryId", countryObj.id, true);
          updateForm("countryAlpha2", event.target.value, true);
          updateForm("stateId", "", true); // Clear the stateId field
        }
      );
    },
    updateCountryFromGoogle(googleCountryAlpha, googleCountryState) {
      const findCountry = this.countries.find(
        (country) => googleCountryAlpha === country.value
      );
      this.updateForm("countryId", findCountry.id, false);
      this.updateForm("countryAlpha2", findCountry.value, false);
      this.getCountryStates(findCountry.id, googleCountryState);
    },
    getCountryStates(id, googleCountryState) {
      const { dispatch } = this.$store;
      dispatch(`${MODULES.COUNTRY}/getCountryStatesById`, id).then(() => {
        this.updatePaymentFormState(PAYMENT_FORMS.web, "stateId", "", false);
        this.updateCountryStateFromGoogle(googleCountryState);
      });
    },
    // use regex to remove special characters, accents and put in lowercase
    updateCountryStateFromGoogle(googleCountryState) {
      if (googleCountryState) {
        const normalizedGoogleCountryState = googleCountryState
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/\s+/g, "");
        const state = this.states.find(
          (cstate) =>
            cstate.label
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .replace(/\s+/g, "")
              .toLowerCase() === normalizedGoogleCountryState.toLowerCase()
        );
        if (state) {
          this.updateForm("stateId", state.value.toString(), true);
        }
      } else {
        this.updateForm("stateId", "", false);
      }
    },
    calculateHeadsetPrice(plan) {
      if (!plan || !plan.included_product) {
        return 0;
      }
      return Number(plan.included_product.price.amount);
    },
    getSelectedPlan(planId) {
      return this.availablePlans.find((p) => Number(p.id) === Number(planId));
    },
    getSubscriptionSummary() {
      const { plan_id, promoApplied } = this.formData;
      if (!plan_id) {
        return {
          id: "subscription_description",
          label: "Subscription",
          value: null,
          rawValue: 0,
        };
      }
      const selectedPlan = this.getSelectedPlan(plan_id.value);
      if (!selectedPlan) {
        return;
      }
      let billingText = null;
      const totalCost = this.getTotalCost()?.rawValue;
      const priceExplanationText = this.getTotalCost()?.priceExplanationText;
      const discount = this.getDiscountAmount()?.rawValue;
      if (promoApplied.value) {
        if (totalCost === 0) {
          billingText = "With this Promo code your subscription fee is waived.";
        } else if (totalCost + discount === 0) {
          billingText = "With this Promo code your subscription fee is waived.";
        } else if (totalCost > 0) {
          billingText = priceExplanationText;
        }
      } else {
        billingText = priceExplanationText;
      }
      if (selectedPlan.discount_reason) {
        billingText = `<b>${selectedPlan.discount_reason}</b> ${billingText}`;
      }
      return {
        id: "subscription_description",
        label: "Subscription",
        value: billingText,
        rawValue: Number(
          (selectedPlan.first_month_price || selectedPlan.price).amount
        ),
      };
    },
    getTotalCost() {
      let summaryTotal = 0;
      let showTotal = false;
      let collectPaymentDetails = true;
      let priceExplanationText = null;
      if (this.orderSummary) {
        const {
          delivery_method,
          voucher,
          collect_payment_details,
          price_explanation_text,
        } = this.orderSummary;
        const { headsetType } = this.formData;
        if (delivery_method) {
          showTotal = true;
        }
        if (voucher) {
          if (headsetType.value === "none") {
            showTotal = true;
          }
        } else if (headsetType.value === "none") {
          showTotal = true;
        }

        if (this.bespokeReferrer) {
          showTotal = true;
        }

        collectPaymentDetails = collect_payment_details;
        priceExplanationText = price_explanation_text;
        summaryTotal = Number(this.orderSummary.total.amount);
      }
      summaryTotal = Math.abs(summaryTotal);
      return {
        id: "total_price",
        label: "Total",
        value: `${
          showTotal ? `$${summaryTotal.toFixed(2)} USD` : "To be calculated"
        }`,
        rawValue: Number(summaryTotal.toFixed(2)),
        collectPaymentDetails,
        priceExplanationText,
      };
    },
    getDiscountAmount() {
      const { orderSummary } = this;
      let discount = null;
      if (orderSummary) {
        const { voucher } = orderSummary;
        if (voucher) {
          discount = {
            id: "voucher_discount_amount",
            label: "Discount",
            rawValue: Number(voucher.discount.amount),
            value: `$${Number(voucher.discount.amount).toFixed(2)}`,
          };
          if (this.formData.headsetType.value === "none") {
            const plan = this.getSelectedPlan(this.formData.plan_id.value);
            const headsetPrice = this.calculateHeadsetPrice(plan);
            discount = {
              ...discount,
              rawValue: Number(voucher.discount.amount) - headsetPrice,
              value: `$${(
                Number(voucher.discount.amount) - headsetPrice
              ).toFixed(2)}`,
            };
          }
        }
      }
      return discount;
    },
    getSummaryItems() {
      const { orderSummary } = this;
      const subscriptionSummary = this.getSubscriptionSummary();
      if (!subscriptionSummary) {
        return;
      }
      const plan = this.getSelectedPlan(this.formData.plan_id.value);
      const headsetPrice = this.calculateHeadsetPrice(plan);
      let summaryHeadsetPrice = 0,
        deliveryCosts = null,
        subscriptionCost = subscriptionSummary.rawValue,
        discount = null;
      if (orderSummary) {
        const { delivery_method, voucher } = orderSummary;
        summaryHeadsetPrice = Number(headsetPrice);
        if (delivery_method) {
          deliveryCosts = Number(delivery_method.amount.amount);
        }
        if (voucher) {
          discount = this.getDiscountAmount();
        }
      }
      let sumList = [{ ...discount }, { ...this.getTotalCost() }];
      if (this.formData.headsetType.value !== "none") {
        console.log({
          headsetPrice,
          subscriptionCost,
          first_month_price: plan.first_month_price.amount,
          price: plan.price.amount,
        });
        // first month price is exactly the headset price
        if (headsetPrice === subscriptionCost) {
          subscriptionCost = 0;
          summaryHeadsetPrice = headsetPrice;
        }
        // headset is free
        else if (
          !plan.first_month_price ||
          plan.first_month_price.amount == plan.price.amount
        ) {
          summaryHeadsetPrice = 0;
        }
        // first month free
        else if (
          plan.first_month_price &&
          plan.first_month_price.amount > plan.price.amount
        ) {
          summaryHeadsetPrice =
            Number(plan.first_month_price.amount) - Number(plan.price.amount);
          subscriptionCost = Number(plan.price.amount);
        } else {
          subscriptionCost -= headsetPrice;
        }

        sumList = [
          {
            id: "vr_headset_price",
            value: `${
              summaryHeadsetPrice === 0
                ? "Free"
                : `$${summaryHeadsetPrice.toFixed(2)} USD`
            }`,
            label: "VR Headset",
            rawValue: summaryHeadsetPrice,
          },
          {
            id: "shipping_price",
            value:
              deliveryCosts === 0
                ? "Free"
                : deliveryCosts !== null
                ? `$${deliveryCosts.toFixed(2)} USD`
                : "To be calculated",
            label: "Shipping",
            rawValue: deliveryCosts,
          },
          ...sumList,
        ];
      }
      sumList = [
        {
          id: "subscription_cost",
          label: "Subscription start",
          rawValue: subscriptionCost,
          value:
            subscriptionCost === 0
              ? "FREE"
              : `$${subscriptionCost.toFixed(2)} USD`,
        },
        ...sumList,
      ];
      return sumList;
    },
    formIsValid(hasFullDiscount) {
      if (this.easeUpReferrer || this.vapingReferrer) {
        return true;
      }
      if (!this.addressUnderstood && this.allianzReferrer) {
        return false;
      }
      if (this.headsetType === "none" && this.cardDetailsAreCompleted) {
        return true;
      } else if (this.headsetType === "none" && hasFullDiscount) {
        return true;
      }
      let keys = Object.keys(this.formData);
      const properties = (validator, key) =>
        Object.prototype.hasOwnProperty.call(validator, key);
      const formIsValid = !keys.some((key) => {
        if (properties(this.validator, key)) {
          if (key === "stateId" && this.countryHasNoStates()) {
            return false;
          }
          return !this.validator[key](this.formData[key].value).valid;
        }
        return false;
      });
      if (!hasFullDiscount) {
        return formIsValid && this.cardDetailsAreCompleted;
      }
      return formIsValid;
    },
    updatePaymentFormState(formName, field, value, touched) {
      this.updateFormState(formName, field, value, touched);
      if (field === "countryId") {
        const payload = {
          country_id: value,
        };
        this.getCountryDeliveryMethods(formName, payload);
      }
    },
    getCountryDeliveryMethods(formName, payload) {
      const { dispatch } = this.$store;
      dispatch(`${MODULES.COUNTRY}/getCountryDeliveryMethods`, payload).then(
        (data) => {
          if (data.length > 0) {
            const payload = {
              delivery_method_id: data[0].id,
              voucher_code: this.formData.promoApplied.value,
            };
            this.getSaleSummary(formName, payload);
          }
        }
      );
    },
    getPaymentType() {
      return this.onboardingData.choose_path === PAGE_PATH.parent
        ? "parent"
        : "premium";
    },
    getSaleSummary(formName, payload) {
      const { dispatch } = this.$store;
      const denormaliser = (param) =>
        this.headsetType !== "none"
          ? denormaliseOrderSummary(param)
          : denormaliseNoHeadsetOrderSummary(param);
      let data = {
        ...denormaliser(this.formData),
        ...payload,
        email: this.formData.email.value,
        paymentType: this.getPaymentType(),
      };
      dispatch(`${MODULES.PAYMENT}/getSaleSummaryAction`, data).then(
        (saleSummary) => {
          if (payload?.delivery_method_id) {
            this.updatePaymentFormState(
              formName,
              "deliveryMethod",
              payload.delivery_method_id,
              false
            );
          }
          if (saleSummary.voucher) {
            this.updatePaymentFormState(
              formName,
              "promoApplied",
              saleSummary.voucher.voucher_code,
              false
            );
          } else {
            this.updatePaymentFormState(formName, "promoApplied", "", false);
          }
          if (this.autoLoadPromoCode) {
            this.updatePaymentFormState(
              formName,
              "promoApplied",
              this.$route.query.code,
              false
            );
            this.promoApplied = true;
          }
          this.updatePaymentFormState(formName, "promoCode", "", false);
        }
      );
    },
    trackUserError(error, paid) {
      if (error && window?.analytics && window?.analytics?.track) {
        window.analytics.track(
          `New User - ${paid ? "Error after payment" : "Credit card issue"}`,
          {
            Host: "Web",
            errorMessage: error,
          }
        );
      }
    },
    chainError(err) {
      const error = this.isProduction
        ? err?.paid
          ? "Oh no - we received your payment, but something else went wrong. Sorry about that! Please contact oVRcome support: support@ovrcome.io"
          : err?.message ||
            (err?.error &&
              err?.error.replace("Delivery method can't be blank", "")) ||
            "Something went wrong. Please contact oVRcome support: support@ovrcome.io"
        : err?.message || err?.error;
      this.isLoadingStripePayment = false;
      this.isLoadingVoucherProcess = false;
      this.errorMessage = error;
      this.trackUserError(error);
      return Promise.reject(err);
    },
    reduceSummaryToHashMap() {
      const result = this.getSummaryItems().reduce(function (map, obj) {
        map[obj.id] = obj;
        return map;
      }, {});
      return result;
    },
    trackUserSuccess(startPaymentData) {
      if (!window?.analytics || !window?.analytics?.track) {
        return;
      }
      const { countryAlpha2, headsetType, stateId, plan_id, user_id } =
        this.formData;
      const { age_select, choose_path, choose_phobias } = this.onboardingData;
      this.errorMessage = null;
      const planDetails = this.getSelectedPlan(plan_id.value);
      const programCategoryId =
        choose_path === PAGE_PATH.parent ? age_select : choose_phobias;
      const selectedCountry = this.countries.find(
        (country) => countryAlpha2.value === country.value
      );
      const selectedState = this.states.find(
        (state) => Number(state.value) === Number(stateId.value)
      );
      const payload = {
        Host: "Web",
        headsetCountry: selectedCountry?.label,
        HeadsetPurchased: headsetType.value,
        headsetState: selectedState ? selectedState.label : null,
        courseType: planDetails.programme_type,
        subscriptionPeriod: planDetails.billing_units,
        programmeCategory: programCategoryId,
        programmeCategoryName: getCategoryById(programCategoryId).title,
        revenue: this.getTotalCost().rawValue, // This is wrong, the revenue will differ with voucher_codes.
        currency: planDetails.price.name,
      };
      window.analytics.identify(
        user_id?.value,
        {
          ...payload,
        },
        {},
        () => window.analytics.track("New User - Subscription Started", payload)
      );
      if (window?.dataLayer?.push()) {
        window.dataLayer.push({ event: "onboarding_purchased" });
      }
      if (window?.gtag) {
        const gtagPayload = {
          ...payload,
          ...this.orderSummary,
          ...this.formData,
          ...startPaymentData,
          ...this.getTotalCost(),
          ...this.reduceSummaryToHashMap(),
          paymentType: this.getPaymentType(),
        };
        window.gtag("event", "purchase", purchase_event_payload(gtagPayload));
      }
    },
    handleSetCurrentPage() {
      const { action, formData } = this;
      action(formData.email.value);
    },
    cleanFormData(form) {
      let denormalisedPayload = denormaliseWebPaymentForm(form);
      Object.keys(denormalisedPayload).forEach((key) => {
        if (!denormalisedPayload[key]) {
          delete denormalisedPayload[key];
        }
      });
      return denormalisedPayload;
    },
    submitVoucherProcess: async function () {
      const { dispatch } = this.$store;
      const {
        name_input,
        choose_path,
        choose_phobias,
        age_select,
        choose_gender,
      } = this.onboardingData;
      const form = this.formData;
      this.isLoadingVoucherProcess = true;
      const denormalisedPayload = this.cleanFormData(form);
      const isParent = choose_path === PAGE_PATH.parent;
      let payload = {
        item_type: "Plan",
        item_id: form.plan_id.value,
      };
      if (!isParent) {
        payload = {
          ...payload,
          category_id: choose_phobias,
          paymentType: "premium",
        };
        if (form.referrer.value && form.referrer.value !== "d2c_vaping") {
          //we want d2c_vaping to be treated as a standalone sale
          payload.referrer = form.referrer.value;
        }
      } else if (isParent) {
        payload = {
          ...payload,
          category_id: age_select,
          parent_first_name: form.name.value,
          gender: choose_gender,
          first_name: name_input,
          paymentType: "parent",
        };
      }
      dispatch(`${MODULES.PAYMENT}/submitPayment`, {
        ...denormalisedPayload,
        ...payload,
        email: this.formData.email.value,
      })
        .then((data) => {
          const queryObj = queryString.parse(
            data?.receipt_url?.split("?")?.[1]
          );
          let paymentData = data;
          if (queryObj?.sale_id) {
            paymentData = { ...paymentData, sale_id: queryObj.sale_id };
          }
          this.trackUserSuccess(paymentData);
        })
        .then(() => this.handleSetCurrentPage())
        .catch(this.chainError);
    },
    updateAddressFormWithDefaultForEaseup() {
      const that = this;
      setTimeout(function () {
        that.updateForm("address", "105 Bay View Road", true);
        that.updateForm("locality", "Christchurch", true);
        that.updateForm("stateId", "3259", true);
        that.updateForm("countryId", "240", true);
        that.updateForm("countryAlpha2", "NZ", true);
        that.updateForm("postal", "8081", false);
      }, 2000);
    },
    submitStripeProcess: async function (stripe, paymentElement) {
      this.checkFormFilled();
      if (!this.formIsValid()) {
        this.errorMessage = "Please fill in all required fields";
        return;
      }
      const { chainError, formData: form } = this;
      const { dispatch } = this.$store;
      const {
        choose_gender,
        name_input,
        choose_path,
        age_select,
        choose_phobias,
      } = this.onboardingData;
      const isParent = choose_path === PAGE_PATH.parent;
      const denormalisedPayload = this.cleanFormData(form);
      this.isLoadingStripePayment = true;
      await stripe
        .createPaymentMethod({
          type: "card",
          card: paymentElement,
          billing_details: {
            name: form.name.value,
          },
        })
        .then((stripeData) => {
          const err = stripeData?.paymentMethod?.error || stripeData?.error;
          if (err) {
            return chainError({
              message: err?.message,
            });
          }
          let extraData = {
            item_type: "Plan",
            item_id: this.formData.plan_id.value,
          };
          if (!isParent) {
            extraData = {
              ...extraData,
              category_id: choose_phobias,
              paymentType: "premium",
            };
            if (form.referrer.value && form.referrer.value !== "d2c_vaping") {
              extraData.referrer = form.referrer.value;
            }
          } else if (isParent) {
            extraData = {
              ...extraData,
              category_id: age_select,
              parent_first_name: this.formData.name.value,
              gender: choose_gender,
              first_name: name_input,
              paymentType: "parent",
            };
          }
          dispatch(`${MODULES.PAYMENT}/submitPayment`, {
            ...denormalisedPayload,
            ...extraData,
            email: this.formData.email.value,
            payment_method_id: stripeData.paymentMethod?.id,
          })
            .then((data) => {
              let confirmData = {};
              if (!isParent) {
                confirmData = {
                  sale_token: data.sale_token,
                  paymentType: "premium",
                };
                if (
                  form.referrer.value &&
                  form.referrer.value !== "d2c_vaping"
                ) {
                  extraData.referrer = form.referrer.value;
                }
              } else if (isParent) {
                confirmData = {
                  token: data.token,
                  requires_action: false,
                  user_id: data.user_id,
                  paymentType: "parent",
                };
              }
              dispatch(`${MODULES.PAYMENT}/confirmPayment`, {
                payment_intent_id: data.payment_intent_id,
                plan_id: form.plan_id.value,
                sale_id: data.sale_id,
                client_secret: data.client_secret,
                ...confirmData,
              })
                .then(() => this.handleSetCurrentPage())
                .then(() => this.trackUserSuccess(data))
                .catch(chainError);
            })
            .catch(chainError);
        })
        .catch(chainError);
    },
  },
};
</script>
